/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarbonEmissionIntensityDto
 */
export interface CarbonEmissionIntensityDto {
    /**
     *
     * @type {number}
     * @memberof CarbonEmissionIntensityDto
     */
    carbonEmissionIntensityId?: number;
    /**
     *
     * @type {string}
     * @memberof CarbonEmissionIntensityDto
     */
    stateCode?: string;
    /**
     * 2 letter ISO country code. Required
     * @type {string}
     * @memberof CarbonEmissionIntensityDto
     */
    countryCode?: string;
    /**
     *
     * @type {number}
     * @memberof CarbonEmissionIntensityDto
     */
    cO2PerWh?: number;
    /**
     *
     * @type {string}
     * @memberof CarbonEmissionIntensityDto
     */
    scopeFactor?: CarbonEmissionIntensityDtoScopeFactorEnum;
    /**
     *
     * @type {Date}
     * @memberof CarbonEmissionIntensityDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof CarbonEmissionIntensityDto
     */
    updatedAt?: Date;
}

/**
 * @export
 */
export const CarbonEmissionIntensityDtoScopeFactorEnum = {
    Scope1: "Scope1",
    Scope2: "Scope2",
    Scope3: "Scope3",
} as const;
export type CarbonEmissionIntensityDtoScopeFactorEnum =
    (typeof CarbonEmissionIntensityDtoScopeFactorEnum)[keyof typeof CarbonEmissionIntensityDtoScopeFactorEnum];

/**
 * Check if a given object implements the CarbonEmissionIntensityDto interface.
 */
export function instanceOfCarbonEmissionIntensityDto(
    value: object,
): value is CarbonEmissionIntensityDto {
    return true;
}

export function CarbonEmissionIntensityDtoFromJSON(
    json: any,
): CarbonEmissionIntensityDto {
    return CarbonEmissionIntensityDtoFromJSONTyped(json, false);
}

export function CarbonEmissionIntensityDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CarbonEmissionIntensityDto {
    if (json == null) {
        return json;
    }
    return {
        carbonEmissionIntensityId:
            json["carbonEmissionIntensityId"] == null
                ? undefined
                : json["carbonEmissionIntensityId"],
        stateCode: json["stateCode"] == null ? undefined : json["stateCode"],
        countryCode:
            json["countryCode"] == null ? undefined : json["countryCode"],
        cO2PerWh: json["cO2PerWh"] == null ? undefined : json["cO2PerWh"],
        scopeFactor:
            json["scopeFactor"] == null ? undefined : json["scopeFactor"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
    };
}

export function CarbonEmissionIntensityDtoToJSON(
    value?: CarbonEmissionIntensityDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        carbonEmissionIntensityId: value["carbonEmissionIntensityId"],
        stateCode: value["stateCode"],
        countryCode: value["countryCode"],
        cO2PerWh: value["cO2PerWh"],
        scopeFactor: value["scopeFactor"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
    };
}
